import store from '@/store'
import StripeModule from '@/store/captain/stripe'

export default function loadStripe() {
  const stripeScript = document.createElement('script')
  stripeScript.onload = () => {
    if (!store.hasModule('stripe')) {
      store.registerModule('stripe', StripeModule)
    }
    // eslint-disable-next-line no-undef
    store.commit('stripe/SET_STRIPE', Stripe(`${process.env.VUE_APP_STRIPE_PUBLIC_KEY}`))
  }
  stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
  document.head.appendChild(stripeScript)
}
